import { FormGroup } from '@angular/forms';
import { MonthYear } from '@app/domain/model/monthYear';
import { QueryReportType } from '@app/feature/dealer/query-reports';


function castToYearMonth( value: any) {
  if (value && (typeof value === 'string')) {
    const valueSplitted = value.toString().split('/').map(Number);
    return { year: valueSplitted[1], month: valueSplitted[0] };
  } else {
    return value;
  }
}


export function validateQueryReportTimeframe(c: FormGroup) {
  // for INDUSTRY queryTo is not displayed
  if (c.get('queryReportType').value === QueryReportType.industry.value) {
    return null;
  }
  const from: MonthYear = castToYearMonth(c.get('queryFrom').value);
  const to: MonthYear = castToYearMonth(c.get('queryTo').value);

  if(typeof from === 'undefined' || !from || !from.month || typeof to === 'undefined' || !to || !to.month){
    return null;
  }

  if(from.year < to.year){
    return null;
  } else if (from.year === to.year) {
    if (from.month <= to.month) {
      return null;
    }
  }

  return {
    queryReportTimeframe: {
      valid: false
    }
  };
}
